import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';
import { AccordionContainer } from './AccordionContainer';
import { AnnualHeroContainer } from './AnnualHeroContainer';
import { AnnualIntroContainer } from './AnnualIntroContainer';
import { AnnualModuleContainer } from './AnnualModuleContainer';
import { AnnualQuoteContainer } from './AnnualQuoteContainer';
import { ArticleContainer } from './ArticleCardsContainer';
import { ArticleHeroContainer } from './ArticleHeroContainer';
import { AukakronurCardsContainer } from './AukakronurCardsContainer';
import { BecomeACustomerContainer } from './BecomeACustomerContainer';
import { BookAppointmentContainer } from './BookAppointmentContainer';
import { BoxesContainer } from './BoxesContainer';
import { BuzzsproutContainer } from './BuzzsproutContainer';
import { CompactHeroContainer } from './CompactHeroContainer';
import { ContentNavContainer } from './ContentNavContainer';
import { DownloadLinksContainer } from './DownloadLinksContainer';
import { EmbedContainer } from './EmbedContainer';
import { EmphasisContainer } from './EmphasisContainer';
import { EventRegistrationContainer } from './EventRegistrationContainer';
import { FaqContainer } from './FaqContainer';
import { FeaturedArticlesContainer } from './FeaturedArticlesContainer';
import { FeaturedPodcastsContainer } from './FeaturedPodcastsContainer';
import { FrontPageHeroContainer } from './FrontPageHeroContainer';
import FundsContainer from './FundsContainer';
import { GdprRequestContainer } from './GdprRequestContainer';
import { HighlightNumbersContainer } from './HighlightNumbersContainer';
import { IframeContainer } from './IframeContainer';
import { ImagesContainer } from './ImagesContainer';
import { InfogramContainer } from './InfogramContainer';
import { InterestCalloutContainer } from './InterestCalloutContainer';
import { IntroTextContainer } from './IntroTextContainer';
import { JotFormContainer } from './JotFormContainer';
import { KauphollNewsContainer } from './KauphollNewsContainer';
import { MailingListContainer } from './MailingListContainer';
import { MarketsContainer } from './MarketsContainer';
import { MoreInfoContainer } from './MoreInfoContainer';
import { NewsCardsContainer } from './NewsCardsContainer';
import { OrderGiftCardContainer } from './OrderGiftCardContainer';
import { OtherCardsContainer } from './OtherCardsContainer';
import { PaymentCardInfoContainer } from './PaymentCardInfoContainer';
import { PointsContainer } from './PointsContainer';
import { ProductCardsContainer } from './ProductCardsContainer';
import { QuartersContainer } from './QuartersContainer';
import { QuoteContainer } from './QuoteContainer';
import { QuoteExpandContainer } from './QuoteExpandContainer';
import { RelatedContainer } from './RelatedContainer';
import { RichTextContainer } from './RichTextContainer';
import ServiceLocationsContainer from './ServiceLocationsContainer';
import { ShortcutsContainer } from './ShortcutsContainer';
import { StaffWithBioContainer } from './StaffWithBioContainer';
import { StaffWithContactContainer } from './StaffWithContactContainer';
import { SubPageHeroContainer } from './SubPageHeroContainer';
import { TableContainer } from './TableContainer';
import { TableWithImagesContainer } from './TableWithImagesContainer';
import { TableWithLargeTextContainer } from './TableWithLargeTextContainer';
import { TermsDialogContainer } from './TermsDialogContainer';
import { TextCardsContainer } from './TextCardsContainer';
import { TextWithAuthorContainer } from './TextWithAuthorContainer';
import { TextWithIconContainer } from './TextWithIconContainer';
import { TextWithImageContainer } from './TextWithImageContainer';
import { TextWithImagesContainer } from './TextWithImagesContainer';
import { TextWithLinksContainer } from './TextWithLinksContainer';
import { TextWithNumbersContainer } from './TextWithNumbersContainer';
import { TextWithPointsContainer } from './TextWithPointsContainer';
import { TextWithPullOutContainer } from './TextWithPullOutContainer';
import { TextWithRelatedContainer } from './TextWithRelatedContainer';
import { TextWithSideTextContainer } from './TextWithSideTextContainer';
import { TextWithVideoContainer } from './TextWithVideoContainer';
import { TilesContainer } from './TilesContainer';
import { VideoContainer } from './VideoContainer';
import { VideoElContainer } from './VideoElContainer';

const CustomModuleContainer = dynamic(() => import('./CustomModuleContainer'));
const HousingLoanCalculatorContainer = dynamic(
  () => import('./HousingLoanCalculatorContainer'),
);

interface IProps {
  data: any;
  template?: string;
}

enum SliceType {
  AnnualHero = 'annual_report_hero',
  SUBHERO = 'hero',
  FRONTPAGEHERO = 'frontpage_hero',
  COMPACTHERO = 'compact_hero',
  TEXT = 'text',
  TEXT_WITH_AUTHORS = 'text_with_authors',
  TEXT_WITH_SIDE_TEXT = 'text_with_side_text',
  TEXT_WITH_IMAGE = 'text_with_image',
  TEXT_WITH_IMAGES = 'text_with_images',
  TEXT_WITH_VIDEO = 'text_with_video',
  TEXT_WITH_RELATED = 'text_with_related',
  TEXT_WITH_LINKS = 'text_with_links',
  TEXT_WITH_POINTS = 'text_with_points',
  TEXT_WITH_PULL_OUT = 'text_with_pull_out',
  TEXT_WITH_ICON = 'text_with_icon',
  POINTS = 'points',
  INTRO_TEXT = 'intro_text',
  EMPHASIS_TEXT = 'emphasis_text',
  QUOTE = 'quote',
  IMAGES = 'images',
  VIDEO = 'video',
  EMBED = 'embed',
  TABLE = 'table',
  TABLE_WITH_IMAGES = 'table_with_images',
  FAQ = 'faq',
  CONTENT_INDEX_NAV = 'content_nav',
  INTEREST_CALLOUT = 'interest_callout',
  STAFF_WITH_CONTACT = 'staff_with_contact',
  STAFF_WITH_BIO = 'staff_with_bio',
  RELATED_CONTENT = 'related_content',
  PRODUCT_CARDS = 'product_cards',
  ARTICLE_CARDS = 'article_cards',
  NEWS_CARDS = 'news_cards',
  OTHER_CARDS = 'other_cards',
  MORE_INFO = 'more_info',
  TEXT_CARDS = 'text_cards',
  CARD_INFO = 'card_info',
  CUSTOM_MODULE = 'custom_module',
  BECOME_A_CUSTOMER = 'become_a_customer',
  HOUSING_LOAN_CALCULATOR = 'housing_loan_calculator',
  DOWNLOAD_LINKS = 'download_links',
  IFRAME = 'iframe',
  MAILING_LIST = 'mailing_list',
  MARKETS = 'markets',
  INFOGRAM = 'infogram',
  BUZZSPROUT = 'buzzsprout',
  EVENT_REGISTRATION = 'event_sign_up',
  SERVICE_LOCATIONS = 'service_locations',
  ACCORDION = 'accordion',
  QUARTERTS = 'quarters',
  HIGHLIGHT_NUMBERS = 'highlight_numbers',
  SHORTCUTS = 'shortcuts',
  VIDEOEL = 'video_el',
  GDPR = 'gdprrequest',
  ARTICLE_HERO = 'article_hero',
  FEATURED_ARTICLES = 'featured_articles',
  FEATURED_PODCASTS = 'featured_podcasts',
  ORDER_GIFT_CARD = 'order_gift_card',
  ANNUAL_MODULE = 'annual_module',
  TILES = 'tiles',
  ANNUAL_INTRO = 'annual_intro',
  ANNUAL_QUOTE = 'annual_quote',
  QUOTE_EXPAND = 'quote_expand',
  TEXT_WITH_NUMBERS = 'text_with_numbers',
  BOXES = 'boxes',
  TABLE_WITH_LARGE_TEXT = 'table_with_large_text',
  BOOK_APPOINTMENT = 'book_appointment',
  TERMS_DIALOG = 'terms_dialog',
  KAUPHOLL_NEWS = 'kaupholl_news',
  JOTFORM = 'jotform',
  IMAGE_LINK = 'image_link',
  SJODIR = 'sjodir',
}

export const Slices = ({ data, template }: IProps) => {
  const router = useRouter();
  return (
    <>
      {(data || []).map((s: any, i: number) => {
        const key = `slice${s.type}-${i}`;
        const props = { ...s, ...s.primary };

        if (
          router?.query?.onlyslicetype &&
          router?.query?.onlyslicetype !== s.type
        ) {
          return null;
        }
        // eslint-disable-next-line sonarjs/max-switch-cases
        switch (s.type) {
          case SliceType.AnnualHero:
            return <AnnualHeroContainer key={key} {...props} />;
          case SliceType.SUBHERO:
            return <SubPageHeroContainer key={key} {...props} />;
          case SliceType.FRONTPAGEHERO:
            return <FrontPageHeroContainer key={key} {...props} />;
          case SliceType.COMPACTHERO:
            return <CompactHeroContainer key={key} {...props} />;
          case SliceType.TEXT:
            return (
              <RichTextContainer key={key} {...props} template={template} />
            );
          case SliceType.TEXT_WITH_IMAGE:
            return (
              <TextWithImageContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_IMAGES:
            return (
              <TextWithImagesContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_RELATED:
            return (
              <TextWithRelatedContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_AUTHORS:
            return (
              <TextWithAuthorContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_SIDE_TEXT:
            return (
              <TextWithSideTextContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_VIDEO:
            return (
              <TextWithVideoContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_LINKS:
            return (
              <TextWithLinksContainer
                key={key}
                {...props}
                template={template}
              />
            );

          case SliceType.TEXT_WITH_POINTS:
            return (
              <TextWithPointsContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_PULL_OUT:
            return (
              <TextWithPullOutContainer
                key={key}
                {...props}
                template={template}
              />
            );
          case SliceType.TEXT_WITH_ICON:
            return <TextWithIconContainer key={key} {...props} />;
          case SliceType.POINTS:
            return <PointsContainer key={key} {...props} template={template} />;
          case SliceType.INTRO_TEXT:
            return (
              <IntroTextContainer key={key} {...props} template={template} />
            );
          case SliceType.EMPHASIS_TEXT:
            return (
              <EmphasisContainer key={key} {...props} template={template} />
            );
          case SliceType.QUOTE:
            return <QuoteContainer key={key} {...props} template={template} />;
          case SliceType.IMAGES:
            return <ImagesContainer key={key} {...props} template={template} />;
          case SliceType.VIDEO:
            return <VideoContainer key={key} {...props} />;
          case SliceType.EMBED:
            return <EmbedContainer key={key} {...props} />;
          case SliceType.TABLE:
            return <TableContainer key={key} {...props} />;
          case SliceType.TABLE_WITH_IMAGES:
            return <TableWithImagesContainer key={key} props {...props} />;
          case SliceType.FAQ:
            return <FaqContainer key={key} {...props} />;
          case SliceType.CONTENT_INDEX_NAV:
            return <ContentNavContainer key={key} {...props} />;
          case SliceType.INTEREST_CALLOUT:
            return <InterestCalloutContainer key={key} {...props} />;
          case SliceType.STAFF_WITH_CONTACT:
            return (
              <StaffWithContactContainer
                id="Staff_with_Contact"
                key={key}
                {...props}
              />
            );
          case SliceType.STAFF_WITH_BIO:
            return <StaffWithBioContainer key={key} {...props} />;
          case SliceType.RELATED_CONTENT:
            return <RelatedContainer key={key} {...props} />;
          case SliceType.PRODUCT_CARDS:
            return <ProductCardsContainer key={key} {...props} />;
          case SliceType.ARTICLE_CARDS:
            return <ArticleContainer key={key} {...props} />;
          case SliceType.NEWS_CARDS:
            return <NewsCardsContainer key={key} {...props} />;
          case SliceType.OTHER_CARDS:
            return <OtherCardsContainer key={key} {...props} />;
          case SliceType.MORE_INFO:
            return <MoreInfoContainer key={key} {...props} />;
          case SliceType.TEXT_CARDS:
            return <TextCardsContainer key={key} {...props} />;
          case SliceType.CUSTOM_MODULE:
            return <CustomModuleContainer key={key} {...props} />;
          case SliceType.DOWNLOAD_LINKS:
            return <DownloadLinksContainer key={key} {...props} />;
          case SliceType.IFRAME:
            return <IframeContainer key={key} {...props} />;
          case SliceType.INFOGRAM:
            return <InfogramContainer key={key} {...props} />;
          case SliceType.BUZZSPROUT:
            return <BuzzsproutContainer key={key} {...props} />;
          case SliceType.ACCORDION:
            return <AccordionContainer key={key} {...props} />;
          case SliceType.QUARTERTS:
            return <QuartersContainer key={key} {...props} />;
          case SliceType.HIGHLIGHT_NUMBERS:
            return <HighlightNumbersContainer key={key} {...props} />;
          case SliceType.SHORTCUTS:
            return <ShortcutsContainer key={key} {...props} />;
          case SliceType.VIDEOEL:
            return <VideoElContainer key={key} {...props} />;
          case SliceType.ARTICLE_HERO:
            return <ArticleHeroContainer key={key} {...props} />;
          case SliceType.FEATURED_ARTICLES:
            return <FeaturedArticlesContainer key={key} {...props} />;
          case SliceType.FEATURED_PODCASTS:
            return <FeaturedPodcastsContainer key={key} {...props} />;
          case SliceType.ANNUAL_MODULE:
            return <AnnualModuleContainer key={key} {...props} />;
          case SliceType.TILES:
            return <TilesContainer key={key} {...props} />;
          case SliceType.ANNUAL_INTRO:
            return <AnnualIntroContainer key={key} {...props} />;
          case SliceType.ANNUAL_QUOTE:
            return <AnnualQuoteContainer key={key} {...props} />;
          case SliceType.QUOTE_EXPAND:
            return <QuoteExpandContainer key={key} {...props} />;
          case SliceType.TEXT_WITH_NUMBERS:
            return <TextWithNumbersContainer key={key} {...props} />;
          case SliceType.BOXES:
            return <BoxesContainer key={key} {...props} />;
          case SliceType.TABLE_WITH_LARGE_TEXT:
            return <TableWithLargeTextContainer key={key} {...props} />;
          case SliceType.BECOME_A_CUSTOMER:
            return <BecomeACustomerContainer key={key} {...props} />;
          case SliceType.HOUSING_LOAN_CALCULATOR:
            return <HousingLoanCalculatorContainer key={key} {...props} />;
          case SliceType.CARD_INFO:
            return (
              <PaymentCardInfoContainer
                className="payment-info"
                key={key}
                {...props}
              />
            );
          case SliceType.CUSTOM_MODULE:
            return <CustomModuleContainer key={key} {...props} />;
          case SliceType.MAILING_LIST:
            return <MailingListContainer key={key} {...props} />;
          case SliceType.MARKETS:
            return <MarketsContainer key={key} {...props} />;
          case SliceType.ORDER_GIFT_CARD:
            return <OrderGiftCardContainer key={key} {...props} />;
          case SliceType.BOOK_APPOINTMENT:
            return <BookAppointmentContainer key={key} {...props} />;
          case SliceType.EVENT_REGISTRATION:
            return <EventRegistrationContainer key={key} {...props} />;
          case SliceType.GDPR:
            return <GdprRequestContainer key={key} {...props} />;
          case SliceType.SERVICE_LOCATIONS:
            return <ServiceLocationsContainer key={key} {...props} />;
          case SliceType.JOTFORM:
            return <JotFormContainer key={key} {...props} />;
          case SliceType.TERMS_DIALOG:
            return <TermsDialogContainer key={key} {...props} />;
          case SliceType.KAUPHOLL_NEWS:
            return <KauphollNewsContainer key={key} {...props} />;
          case SliceType.IMAGE_LINK:
            return <AukakronurCardsContainer key={key} {...props} />;
          case SliceType.SJODIR:
            return <FundsContainer key={key} {...props} />;
          default:
            if (s.type) {
              console.warn('No slice available for %s %o', s.type, s); // tslint:disable-line
            }
            return null;
        }
      })}
    </>
  );
};
